<template>
  <q-dialog :visible.sync="isVisible" title="新增申请" width="500px" :innerScroll="false" @close="onCancel">
    <div class="reject-content">
      <el-form ref="rejectForm" :model="formData" :rules="rules" size="mini" label-width="110px">
        <el-form-item label="商品编码：" prop="goodsCode">
          <el-input v-model="formData.goodsCode" placeholder="请输入商品编码" maxlength="50"></el-input>
        </el-form-item>

        <el-form-item label="特殊直播价：" prop="livePrice">
          <el-input-number v-model="formData.livePrice" placeholder="请输入直播价" :controls="false" :min="1" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="直播佣金：" prop="liveRebate">
          <el-select v-model="formData.liveRebate" placeholder="10%">
            <el-option label="10%" value="0.1"></el-option>
            <el-option label="15%" value="0.15"></el-option>
            <el-option label="20%" value="0.2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="最高佣金：" prop="maxLiveRebate" class="maxPirce">
          <el-input-number v-model="formData.maxLiveRebate" placeholder="请输入最高佣金" :min="1" :precision="0" :controls="false"></el-input-number>
          <span>%</span>
        </el-form-item>

        <el-form-item label="申请原因：" prop="reason">
          <el-input v-model="formData.reason" type="textarea" :rows="4" placeholder="请输入申请原因" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </div>
    <template v-slot:footer>
      <div class="dialog-footer">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitting">提交</el-button>
      </div>
    </template>
  </q-dialog>
</template>

<script>
import NP from 'number-precision'
export default {
  name: 'NewApplicationDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      submitting: false,
      formData: {
        goodsCode: '',
        livePrice: undefined,
        liveRebate: '0.1',
        maxLiveRebate: undefined,
        reason: '',
      },
      rules: {
        goodsCode: [{ required: true, message: '请输入商品编码', trigger: 'blur' }],
        livePrice: [{ required: true, message: '请输入特殊直播价', trigger: 'blur' }],
        liveRebate: [{ required: true, message: '请选择直播佣金', trigger: 'change' }],
        maxLiveRebate: [{ required: false, message: '请输入最高佣金', trigger: 'blur' }],
        reason: [{ required: true, message: '请输入申请原因', trigger: 'blur' }],
      },
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },

    onSubmit() {
      this.$refs.rejectForm.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        let data = {
          ...this.formData,
          maxLiveRebate: NP.divide(this.formData.maxLiveRebate, 100),  
        };
        this.$q.goods
          .goodsLiveSpecialPriceApply({ data: data })
          .then(res => {
            this.$message.success('提交成功');
            this.$emit('success');
            this.isVisible = false;
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input, >>> .el-input-number  {
  width: 100% !important;
}

>>> .maxPirce .el-input-number {
  width: 95% !important;
}

.dialog-footer {
  text-align: center;
  padding-top: 10px;
}
</style>
